import { useState, useMemo } from "react";
import { Outlet } from "react-router-dom";
import { Sidebar } from "../desktop/Sidebar";
import { Topbar } from "../desktop/Topbar";
import { Toast } from "../Toast";
import { FeedbackWidget } from "../FeedbackWidget";
import { IngestAlertBanner } from "../IngestAlertBanner";
import { useSession } from "../../hooks/useSession";
import { env } from "../../lib/env";
import { NewActivitySheet } from "../../screens/NewActivitySheet";
import { ACTIVITY_CATALOG } from "../../data/activityCatalog";
import { useActivityCatalog } from "../../hooks/useActivityCatalog";
import type { ActivityEntry, ActivityIcon } from "../../state/uiStore";

export function DesktopShell() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const session = useSession();
  const { data: backendCatalog } = useActivityCatalog();

  const catalog: ActivityEntry[] = useMemo(() => {
    if (!backendCatalog?.activities?.length) return ACTIVITY_CATALOG;
    return backendCatalog.activities
      .filter((a) => a.active && !a.archived_at)
      .sort((a, b) => a.sort_order - b.sort_order)
      .map((a) => ({
        code: a.code,
        label: a.label,
        sub: a.subtitle,
        ic: (a.icon as ActivityIcon) ?? "briefcase",
        description: a.description || undefined,
        requires_worker_note: a.requires_worker_note,
      }));
  }, [backendCatalog]);

  return (
    <div
      className={`desk-app${env.VITE_FEEDBACK_ENABLED ? " with-feedback" : ""}`}
    >
      <Sidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} />
      <div className="main">
        <Topbar
          online={session.online}
          pendingSync={session.pendingSync}
          attendanceOpen={session.attendanceOpen}
          onBadge={() => void session.badge()}
          onMenuToggle={() => setSidebarOpen((v) => !v)}
        />
        <div className="content">
          <IngestAlertBanner />
          <Outlet />
        </div>
      </div>
      {sidebarOpen && (
        <div
          className="sidebar-backdrop"
          onClick={() => setSidebarOpen(false)}
        />
      )}
      <Toast />
      <NewActivitySheet catalog={catalog} />
      <FeedbackWidget showTrigger />
    </div>
  );
}
